"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _ = require("./..");
var _components = require("../../components");
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ChangePassword = function ChangePassword(_ref) {
  var form = _ref.form,
    formStyles = _ref.formStyles,
    onCancel = _ref.onCancel,
    onSubmit = _ref.onSubmit,
    oldPasswordValidator = _ref.oldPasswordValidator,
    newPasswordValidator = _ref.newPasswordValidator,
    errors = _ref.errors,
    className = _ref.className,
    submittingPassword = _ref.submittingPassword,
    showButtons = _ref.showButtons,
    setShowButtons = _ref.setShowButtons;
  var getFieldDecorator = form.getFieldDecorator,
    resetFields = form.resetFields;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    confirmDirty = _useState2[0],
    setConfirmDirty = _useState2[1];
  var _useIdentity = (0, _.useIdentity)(),
    identity = _useIdentity.identity;
  var _ref2 = identity || {},
    email = _ref2.email,
    nickName = _ref2.nickName;
  var isFormInvalid = (0, _utils.useFormInvalid)(form);
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    form.validateFieldsAndScroll(function (err, values) {
      if (!err) {
        onSubmit(values);
      }
    });
    resetFields();
  };
  var compareToFirstPassword = function compareToFirstPassword(rule, value, callback) {
    if (value && value !== form.getFieldValue('password')) {
      callback('Oops! Your passwords don’t match.');
    } else {
      callback();
    }
  };
  var validateToNextPassword = function validateToNextPassword(rule, value, callback) {
    if (value && confirmDirty) {
      form.validateFields(['confirmPassword'], {
        force: true
      });
    }
    callback();
  };
  var handleCancel = (0, _react.useCallback)(function (event) {
    if (event) {
      event.preventDefault();
    }
    resetFields();
    if (onCancel) {
      onCancel();
    }
    if (setShowButtons) {
      setShowButtons(false);
    }
  }, [onCancel, resetFields]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: submittingPassword
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit,
    className: (0, _classnames.default)('', formStyles),
    onChange: function onChange() {
      form.validateFields();
      if (setShowButtons) {
        setShowButtons(true);
      }
      setConfirmDirty(true);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-label-medium"
  }, "Change password")), getFieldDecorator('oldPassword', {
    rules: [{
      required: true,
      message: 'Please enter your current password'
    }, {
      validator: oldPasswordValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_.Password, {
    label: "Current password",
    form: form
  })), getFieldDecorator('password', {
    rules: [{
      required: true,
      message: 'Please enter your new password'
    }, {
      validator: validateToNextPassword
    }, {
      validator: (0, _utils.passwordValidator)({
        email: email,
        nickName: nickName
      })
    }, {
      validator: newPasswordValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_.Password, {
    label: "New password",
    form: form,
    showtooltip: true
  })), getFieldDecorator('confirmPassword', {
    rules: [{
      required: true,
      message: 'Please confirm your new password'
    }, {
      validator: compareToFirstPassword
    }]
  })( /*#__PURE__*/_react.default.createElement(_.Password, {
    label: "Confirm new password",
    form: form
  })), showButtons !== undefined ? showButtons && /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-[24px] flex gap-x-[16px]"
  }, /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    htmlType: "submit",
    size: "small",
    className: "min-w-[100px]",
    disabled: isFormInvalid
  }, "Save"), /*#__PURE__*/_react.default.createElement(_components.TextButton, {
    size: "small",
    onClick: handleCancel
  }, "Cancel")) : /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-[24px] flex gap-x-[16px]"
  }, /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    htmlType: "submit",
    size: "small",
    className: "min-w-[100px]",
    disabled: isFormInvalid
  }, "Save"), /*#__PURE__*/_react.default.createElement(_components.TextButton, {
    size: "small",
    onClick: handleCancel
  }, "Cancel")))));
};
var _default = _form.default.create({
  name: 'ChangePassword'
})(ChangePassword);
exports.default = _default;